import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizEntryHeader;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import { Text } from '@instructure/ui-text';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { CondensedButton } from '@instructure/ui-buttons';
import { jsx, Global } from '@instructure/emotion';
import { FillBlankInteractionType } from '@instructure/quiz-interactions';
import { IconBankLine } from '@instructure/ui-icons';
import t from '@instructure/quiz-i18n/format-message';
import { convertFITBtoRich } from '../../../../../../common/util/fitbCopyHelper';
import PositionBox from '../../../../../../common/components/resources/positionBox/PositionBox';
import Item from '../../../../../../common/records/Item';
import ActionButtons from '../../../ActionButtons';
import { DELETED_QUIZ_ENTRY, API_INPUT_VALIDATION_ERROR, BUILD_TRAY_OPEN, Flex, TextInput, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { View } from '@instructure/ui-view';
var QuizEntryHeader = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizEntryHeader = /*#__PURE__*/function (_Component) {
  function QuizEntryHeader() {
    var _this2;
    _classCallCheck(this, QuizEntryHeader);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, QuizEntryHeader, [].concat(args));
    _defineProperty(_this2, "connectDragSource", function (dragHandle) {
      if (_this2.shouldDisableDragHandle()) {
        return dragHandle;
      }
      return _this2.props.connectDragSource(dragHandle);
    });
    _defineProperty(_this2, "clearModifications", function () {
      _this2.props.clearModifications('items', _this2.props.entry.id);
    });
    _defineProperty(_this2, "removeTemporaryItem", function () {
      var remove = function remove() {
        _this2.props.hideError(_this2.props.guid);
        _this2.clearModifications();
        _this2.props.clearTemporaryItem(_this2.props.quizId);
        _this2.props.setUi(DELETED_QUIZ_ENTRY, {
          position: Math.ceil(_this2.props.quizEntry.position),
          inStimulus: _this2.props.quizEntry.hasStimulus
        });
      };
      _this2.props.withConfirm(remove, _this2.removalDialogData());
    });
    _defineProperty(_this2, "removeNormalItem", function () {
      _this2.props.withConfirm(partial(_this2.props.removeQuizEntry, _this2.props.quizId, _this2.props.quizEntry), _this2.removalDialogData());
    });
    _defineProperty(_this2, "removeItem", function (e) {
      if (_this2.props.disabledForRegrade) {
        return null;
      }
      _this2.props.entry.isTemporary() ? _this2.removeTemporaryItem() : _this2.removeNormalItem();
    });
    _defineProperty(_this2, "handleTitleChange", function (event) {
      _this2.props.changeItemTitle(_this2.props.entry.id, event.target.value);
    });
    _defineProperty(_this2, "storeTitleRef", function (el) {
      _this2.titleRef = el;
    });
    _defineProperty(_this2, "copyItem", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var _this2$props, quizId, workingQuizEntry, workingEntry, richFITBEnabled, richFITBInteractionID, msg, validationResult, interactionTypeData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2$props = _this2.props, quizId = _this2$props.quizId, workingQuizEntry = _this2$props.workingQuizEntry, workingEntry = _this2$props.workingEntry, richFITBEnabled = _this2$props.richFITBEnabled, richFITBInteractionID = _this2$props.richFITBInteractionID;
              msg = t('Question {displayPosition} cannot be saved due to invalid input data.', {
                displayPosition: _this2.props.displayPosition
              });
              if (!_this2.props.isValid) {
                _context.next = 14;
                break;
              }
              _context.next = 5;
              return _this2.props.successfulSubmit();
            case 5:
              validationResult = _context.sent;
              if (!(validationResult === API_INPUT_VALIDATION_ERROR)) {
                _context.next = 9;
                break;
              }
              _this2.props.screenreaderNotification(msg);
              return _context.abrupt("return");
            case 9:
              interactionTypeData = {
                answerFeedback: workingEntry.answerFeedback,
                calculatorType: workingEntry.calculatorType,
                feedback: workingEntry.feedback,
                id: workingEntry.interactionType,
                interactionData: workingEntry.interactionData,
                itemBody: workingEntry.itemBody,
                outcomeAlignmentSetGuid: workingEntry.outcomeAlignmentSetGuid,
                properties: workingEntry.properties,
                scoringAlgorithm: workingEntry.scoringAlgorithm,
                scoringData: workingEntry.scoringData,
                title: workingEntry.title
              };
              if (richFITBEnabled && workingEntry.getInteractionType() instanceof FillBlankInteractionType) {
                interactionTypeData = convertFITBtoRich(interactionTypeData, richFITBInteractionID);
              }
              _this2.props.createTempItem(quizId, Math.round(workingQuizEntry.position + 1), interactionTypeData, workingQuizEntry.stimulusQuizEntryId, workingEntry.stimulusId, workingQuizEntry.pointsPossible);
              _context.next = 16;
              break;
            case 14:
              _this2.props.screenreaderNotification(msg);
              _this2.props.showError(_this2.props.guid);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this2, "handleBankClick", function () {
      if (_this2.props.newActiveBank) {
        var bankId = _this2.props.workingQuizEntry.getEntry().id;
        _this2.props.newActiveBank(bankId);
        _this2.props.setUi(BUILD_TRAY_OPEN, true);
      }
    });
    return _this2;
  }
  _inherits(QuizEntryHeader, _Component);
  return _createClass(QuizEntryHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      // timeout is to ensure the screenreader reads the title label when focused
      setTimeout(function () {
        !_this3.props.initialFocusId && _this3.titleRef && _this3.titleRef.focus();
      }, 200); // without the 200, the black VO focus-box, and the actual focus
      // end up in different places after saving, and re-editing
    }
  }, {
    key: "removalDialogData",
    value: function removalDialogData() {
      return {
        title: t('Remove Question?'),
        text: t('Are you sure you want to remove this question?'),
        continueText: t('Remove Question'),
        cancelText: t('Keep Question')
      };
    }
  }, {
    key: "isActiveBank",
    get: function get() {
      return this.props.quizEntry.isBank && this.props.newActiveBank;
    }
  }, {
    key: "isBankEntry",
    get: function get() {
      return this.props.quizEntry.isBank || this.props.quizEntry.isBankEntry;
    }
  }, {
    key: "getVOText",
    value: function getVOText(verb, displayPosition) {
      var name = '';
      if (this.props.entry instanceof Item) {
        name = this.props.entry.getInteractionType().name;
      }
      return t('{verb} Question {questionNumber}, {interactionType}', {
        verb: verb,
        questionNumber: displayPosition,
        interactionType: name
      });
    }
  }, {
    key: "renderItemName",
    value: function renderItemName() {
      return jsx(Text, {
        size: "small",
        weight: "normal",
        "data-automation": "sdk-quiz-entry-interaction-type"
      }, this.props.name);
    }
  }, {
    key: "renderBankNameButton",
    value: function renderBankNameButton() {
      return jsx(CondensedButton, {
        size: "small",
        onClick: this.handleBankClick,
        "data-automation": "sdk-quiz-entry-interaction-type"
      }, this.props.name);
    }
  }, {
    key: "renderTitleHolder",
    value: function renderTitleHolder() {
      if (!(this.props.entry instanceof Item)) return;
      var _this$props = this.props,
        entry = _this$props.entry,
        shouldClone = _this$props.shouldClone,
        quizEntry = _this$props.quizEntry,
        disabledForRegrade = _this$props.disabledForRegrade,
        displayPosition = _this$props.displayPosition,
        workingEntry = _this$props.workingEntry;
      var disabled = disabledForRegrade || entry.isImmutable() && !shouldClone || quizEntry.isBankEntry;
      var titleLabelText = t('Question {questionNumber}, {interactionType}, Edit question title', {
        questionNumber: displayPosition,
        interactionType: entry.getInteractionType().name
      });
      return jsx(TextInput, {
        ref: this.storeTitleRef,
        renderLabel: jsx(Flex, {
          direction: "column",
          gap: "small"
        }, !this.isBankEntry && jsx(Flex.Item, {
          "aria-hidden": true
        }, this.renderItemName()), jsx(Flex.Item, {
          "aria-hidden": true
        }, t('Question Title')), jsx(ScreenReaderContent, null, titleLabelText)),
        type: "text",
        onChange: this.handleTitleChange,
        defaultValue: workingEntry.title || '',
        interaction: disabled ? 'disabled' : 'enabled',
        "data-automation": "sdk-question-title-textinput"
      });
    }
  }, {
    key: "renderLeftHeader",
    value: function renderLeftHeader() {
      var positionText = t('Edit question at position {position, number}', {
        position: this.props.displayPosition
      });
      var position = this.props.disabledForRegrade ? this.props.displayPosition : this.props.quizEntry.positionToDisplay(this.props.displayPosition);
      return jsx(Flex, {
        className: "leftHeader",
        direction: "row",
        alignItems: "center",
        "data-automation": "sdk-quiz-entry-left-header"
      }, jsx(PositionBox, {
        position: position,
        headingText: positionText,
        "data-automation": "sdk-quiz-entry-positionbox"
      }), jsx(Flex.Item, {
        shouldShrink: this.isActiveBank,
        shouldGrow: !this.isActiveBank
      }, jsx(Flex, {
        direction: "row",
        gap: this.isActiveBank ? 'x-small' : 'medium',
        themeOverride: {
          gapMedium: '1.25rem'
        },
        alignItems: "center"
      }, this.isBankEntry && jsx(Flex.Item, null, jsx(IconBankLine, null)), this.isActiveBank ? jsx(Flex.Item, {
        shouldShrink: true
      }, this.renderBankNameButton()) : jsx(Flex.Item, {
        shouldGrow: true
      }, this.renderTitleHolder()))));
    }
  }, {
    key: "render",
    value: function render() {
      var actionButtonProps = {
        connectDragSource: this.connectDragSource,
        deleteText: this.getVOText('Remove', this.props.displayPosition),
        displayPosition: this.props.displayPosition,
        onCopy: this.props.quizEntry.isBank ? null : this.copyItem,
        onDelete: this.removeItem,
        quizEntries: this.props.quizEntries,
        quizEntry: this.props.quizEntry,
        shouldDisableDragHandle: true,
        shouldDisableCopy: this.props.disableSubmit || this.props.disabledForRegrade,
        shouldDisableDeleteButton: this.props.disabledForRegrade,
        shouldRenderEdit: false
      };
      return jsx(View, {
        as: "div",
        className: "header",
        background: "secondary",
        padding: "small"
      }, jsx(Global, {
        styles: this.props.styles.globalStyles
      }), jsx(Flex, {
        className: "header",
        direction: "row",
        alignItems: this.isActiveBank ? 'center' : 'end',
        gap: "small",
        justifyItems: "space-between"
      }, jsx(Flex.Item, {
        shouldShrink: this.isActiveBank,
        shouldGrow: true
      }, this.renderLeftHeader()), jsx(Flex.Item, {
        padding: this.isActiveBank ? '0' : '0 0 xx-small'
      }, jsx(ActionButtons, actionButtonProps))));
    }
  }]);
}(Component), _defineProperty(_QuizEntryHeader, "displayName", 'QuizEntryHeader'), _defineProperty(_QuizEntryHeader, "componentId", "Quizzes".concat(_QuizEntryHeader.displayName)), _defineProperty(_QuizEntryHeader, "propTypes", {
  changeItemTitle: PropTypes.func.isRequired,
  // from connected component
  clearModifications: PropTypes.func.isRequired,
  // from connected component
  clearTemporaryItem: PropTypes.func.isRequired,
  // from connected component
  connectDragSource: PropTypes.func.isRequired,
  // inserted from React DnD
  createTempItem: PropTypes.func.isRequired,
  // from connected component
  disabledForRegrade: PropTypes.bool,
  disableSubmit: PropTypes.bool.isRequired,
  displayPosition: PropTypes.number.isRequired,
  entry: ImmutablePropTypes.record.isRequired,
  guid: PropTypes.string.isRequired,
  hideError: PropTypes.func.isRequired,
  // from connected component
  initialFocusId: PropTypes.string,
  isValid: PropTypes.bool.isRequired,
  name: PropTypes.string,
  newActiveBank: PropTypes.func,
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  quizId: PropTypes.string.isRequired,
  removeQuizEntry: PropTypes.func.isRequired,
  // from connected component
  richFITBEnabled: PropTypes.bool,
  richFITBInteractionID: PropTypes.string,
  screenreaderNotification: PropTypes.func.isRequired,
  setUi: PropTypes.func.isRequired,
  shouldClone: PropTypes.bool,
  showError: PropTypes.func.isRequired,
  successfulSubmit: PropTypes.func.isRequired,
  withConfirm: PropTypes.func.isRequired,
  workingEntry: ImmutablePropTypes.record.isRequired,
  workingQuizEntry: ImmutablePropTypes.record.isRequired,
  styles: PropTypes.object
}), _defineProperty(_QuizEntryHeader, "defaultProps", {
  disabledForRegrade: false,
  initialFocusId: null,
  name: null,
  newActiveBank: null,
  richFITBEnabled: false,
  richFITBInteractionID: '',
  shouldClone: false
}), _QuizEntryHeader)) || _class);
export default QuizEntryHeader;